<div class="chat-container">
  <div class="chat-toolbar">
    <label class="toggle-label">
      <input
        type="checkbox"
        [checked]="showDraftActivity()"
        (change)="toggleDraftActivity()"
      />
      <span>Show draft activity</span>
    </label>
  </div>

  <div class="messages-container status-background" #messagesContainer>
    @if (combinedMessages().length === 0) {
      <div class="no-messages">No activity yet</div>
    } @else {
      @for (msg of combinedMessages(); track trackByMessage($index, msg)) {
        @if (msg.type === 'system' && msg.systemMessage) {
          <div class="system-message">
            <span class="system-text">{{ msg.systemMessage.message }}</span>
            <span class="timestamp">{{ formatTime(msg.timestamp) }}</span>
          </div>
        } @else if (msg.type === 'chat' && msg.chatMessage) {
          <div class="message">
            <div class="message-header">
              @if (msg.chatMessage.user.profile_picture) {
                <img [src]="msg.chatMessage.user.profile_picture" [alt]="msg.chatMessage.user.name" class="avatar" referrerpolicy="no-referrer"/>
              } @else {
                <div class="avatar-placeholder">{{ msg.chatMessage.user.name.charAt(0) }}</div>
              }
              <span class="user-name">{{ msg.chatMessage.user.name }}</span>
              <span class="timestamp">{{ formatTime(msg.chatMessage.timestamp) }}</span>
            </div>
            @if (msg.chatMessage.gif) {
              <div class="message-content message-gif">
                <img
                  [src]="msg.chatMessage.gif.url"
                  [alt]="msg.chatMessage.gif.title"
                  class="gif-image"
                  loading="lazy"
                />
              </div>
            }
            @if (msg.chatMessage.message) {
              <div class="message-content">{{ msg.chatMessage.message }}</div>
            }
          </div>
        }
      }
    }
  </div>

  @if (showGifPicker()) {
    <app-gif-picker
      (gifSelected)="onGifSelected($event)"
      (closed)="toggleGifPicker()"
    />
  }

  <div class="chat-input">
    <button
      class="gif-btn"
      (click)="toggleGifPicker()"
      [class.gif-btn-active]="showGifPicker()"
      [disabled]="!socketService.isConnected()"
      title="Send a GIF"
    >GIF</button>
    <input
      #messageInput
      type="text"
      [ngModel]="newMessage()"
      (ngModelChange)="newMessage.set($event)"
      (keypress)="onKeyPress($event)"
      placeholder="Type a message..."
      [disabled]="!socketService.isConnected()"
    />
    <button (click)="sendMessage()" [disabled]="!socketService.isConnected() || !newMessage().trim()">
      Send
    </button>
  </div>
</div>
